export const nameRegex = /^\s*[a-zA-Z]{3,30}\s*$/gm;
export const gmailRegex =
    /^\w?[a-zA-Z0-9]+\w*([.-]?\w+)*@\w+([-]?\w+)*(.com|.co|.org|.cc){1}(.in|.uk)?$/gm;
export const passwordRegexExp =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

export const organizationNameRegexExp =
    /^\s*[a-zA-Z0-9]+(\s?[a-zA-Z]+)+(\s?[a-zA-Z0-9]+)*\s*$/;
export const usernameRegex = /^(?!.*[_.]{2})[a-zA-Z0-9._]{8,32}$/;
